var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgContributionStep1 = function SvgContributionStep1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "contribution-step-1_svg__\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 40.1 40",
    style: {
      enableBackground: "new 0 0 40.1 40"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".contribution-step-1_svg__st2{fill:#e8eaf1}")), /*#__PURE__*/React.createElement("g", {
    id: "contribution-step-1_svg__\\u7EC4_5634",
    transform: "translate(-211.698 -135.683)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "contribution-step-1_svg__\\u692D\\u5706_1282",
    cx: 219.7,
    cy: 143.7,
    r: 8,
    style: {
      fill: "#be1d32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "contribution-step-1_svg__\\u8DEF\\u5F84_15836",
    d: "m243.7 161.7-8.1 14h16.2l-8.1-14z",
    style: {
      fill: "#172d72"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "contribution-step-1_svg__\\u7EC4_5635",
    transform: "translate(213.774 155.683)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "contribution-step-1_svg__\\u8DEF\\u5F84_15837",
    className: "contribution-step-1_svg__st2",
    d: "M4 0H0c0 9.9 8 17.9 17.9 17.9v-4C10.2 13.9 4 7.7 4 0z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "contribution-step-1_svg__\\u7EC4_5636",
    transform: "translate(231.704 137.753)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "contribution-step-1_svg__\\u8DEF\\u5F84_15838",
    className: "contribution-step-1_svg__st2",
    d: "M17.9 17.9C17.9 8 9.9 0 0 0v4c7.7 0 13.9 6.2 13.9 13.9h4z"
  })))));
};
export default SvgContributionStep1;